import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {RightColumn} from "../../Common/pages/RightColumn";
import {StandardPage} from "../../Common/pages/StandardPage";

export default class FootballLiveHome extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    FootballLiveHomeHeader: PropTypes.element.isRequired,
    FootballLiveHomeVidiprinterContainer: PropTypes.element.isRequired,
    FootballLiveHomeTabs: PropTypes.element.isRequired,
  };

  render() {
    require('./FootballLiveHome.scss');
    const {
      location,
      FootballLiveHomeHeader,
      FootballLiveHomeVidiprinterContainer,
      FootballLiveHomeTabs
    } = this.props;

    return (
      <div className="footballLiveHome">
        <StandardPage sport="football" title="Live Scores" >
          <div className="main-layout-left-column">
            <div className="main-layout-block">
              {FootballLiveHomeHeader}
            </div>
            <div className="main-layout-block main-layout-hide-desktop">
              {FootballLiveHomeVidiprinterContainer}
            </div>
            <div className="main-layout-block last-desktop last-handheld">
              {FootballLiveHomeTabs}
            </div>
          </div>

          <RightColumn location={location}
                       sport="football"
                       content={["topMpu", "vidiPrinter" ,"ocWidget"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballLiveHome.js